import { gql } from '@apollo/client'
import { Region as RegionFragment } from '@/fragments'

export default gql`
  query Regions {
    regions {
      ...region
    }
  }
  ${RegionFragment}
`
